import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    constructor(private messageService: MessageService) {}

    public showSuccess(message: string): void {
        this.messageService.add({ severity: 'success', summary: 'Info', detail: message });
    }

    public showValidationFailed(error: string): void {
        this.messageService.add({ severity: 'warn', summary: '', sticky: true, detail: error });
    }

    public showError(error: string): void {
        this.messageService.add({ severity: 'error', summary: 'Error', sticky: true, detail: error });
    }

    public showWarning(warning: string, sticky = false): void {
        this.messageService.add({ severity: 'warn', summary: 'Warnung', sticky: sticky, detail: warning });
    }
}
